exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-form-group[data-v-43f0d722] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.color-picker[data-v-43f0d722] {\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n[data-v-43f0d722] .md-menu-content.md-select-menu {\n  width: 150px;\n}\n.modal-container[data-v-43f0d722] {\n  max-width: 600px;\n}\n[data-v-43f0d722] .md-switch .md-switch-label {\n  color: #3c4858 !important;\n}\n", ""]);

// exports
